module.exports = __webpack_public_path__ + "img/tarena.9724f3d7.svg";